export default "__VITE_ASSET__CQH3DNkU__"